/**
 * Este componente ha sufrido variaciones a lo largo de los tiempos que han afectado la estructura original.
 * Al algunos de los cambios se han solicitado con urgencia por lo que se debe refactorizar parte del codigo o eliminar
 * codigo que al dia de hoy no se usa.
 * Ultimos cambios importantes:
 * - Migracion de salesforce a db local.
 * - Eliminacion de logica relacionada a CreditRepair: "Hey debemos quitar una logica en leads- cuando dispocionan como “looking for credit repair” en prospect status"
 *
 */
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { UserSettingsService } from "src/app/shared/services/user-setting.service";

@Component({
  selector: "app-lead",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.css"],
  standalone: false,
})
export class LeadComponent implements OnInit {
  loading: boolean;
  constructor(
    private readonly userService: UserSettingsService,
    private readonly router: Router
  ) {}
  statistics = [
    { title: "Total leads worked", value: 10950 },
    { title: "Worked this month", value: 141 },
    { title: "Total converted", value: 12 },
    { title: "Converted this month", value: 10, suffix: "" },
  ];
  avgEmployeeMin = 5;
  costPerMin = 50;
  includeCreationTime = true;

  colorScheme = {
    domain: ["#1890ff"],
  };

  jobRunsData = [
    {
      name: "Total",
      series: [
        { name: "Ene", value: 14 },
        { name: "Feb", value: 11 },
        { name: "Mar", value: 5 },
        { name: "Abr", value: 10 },
        { name: "May", value: 20 },
        { name: "Jun", value: 10 },
      ],
    },
  ];

  hostsData = [
    { name: "Abr", value: 10 },
    { name: "May", value: 4 },
    { name: "Jun", value: 12 },
  ];

  ngOnInit() {
    if (!this.userService.validateToken()) {
      this.userService.logOut();
      this.router.navigateByUrl("/login");
    }
  }
}
